import styled from '@emotion/styled';
import { colors } from '../../constants/colors';

export const ChildrenContainer = styled('div')(({ close }) => ({
  marginTop: 93,
  marginLeft: close ? 100 : 321,
  backgroundColor: colors.LIGHTGREY,
  padding: '35px 35px 0',
}));
